// extracted by mini-css-extract-plugin
export default {"box":"LoadingSpinner_box__j7vn2","spinner":"LoadingSpinner_spinner__LmSHt"};